import { environment } from '@/environments/environment'
export default [
  {
    name: 'getCountriesInCurrentCoverage',
    url: `${environment.newyorkApiUrl}/v3/coverage/in-current-coverage/countries`,
    method: 'get',
    notCancel: true
  },
  {
    name: 'getCountriesCoverage',
    url: `${environment.newyorkApiUrl}/v1/coverage/countries`,
    method: 'get',
    notCancel: true
  },
  {
    name: 'getRatesByCarrierService',
    url: `${environment.newyorkApiUrl}/v3/coverage/carriers/{carrier_id}/services/{service_id}/rates`,
    method: 'get'
  },
  {
    name: 'getServicesByCountryCarrier',
    url: `${environment.newyorkApiUrl}/v3/coverage/countries/{country_id}/carriers/{carrier_id}/services`,
    method: 'get'
  },
  {
    name: 'getServicesInCurrentCoveragesByCountryCarrier',
    url: `${environment.newyorkApiUrl}/v3/coverage/in-current-coverage/countries/{country_id}/carriers/{carrier_id}/services`,
    method: 'get'
  },
  {
    name: 'postImportFutureCoverages',
    url: `${environment.newyorkApiUrl}/v3/coverage/carriers/{carrier_id}/services/{service_id}/import-future-coverages`,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  },
  {
    name: 'postImportInternationalCoverage',
    url: `${environment.newyorkApiUrl}/v3/coverage/carriers/{carrier_id}/services/{service_id}/import-international-coverages`,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  },
  {
    name: 'postImportFutureCoveragesKm',
    url: `${environment.newyorkApiUrl}/v3/coverage/carriers/{carrier_id}/services/{service_id}/import-future-coverages-km`,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  },
  {
    name: 'postImportBigCoverages',
    url: `${environment.newyorkApiUrl}/v3/coverage/countries/{country_id}/carriers/{carrier_id}/services/{service_id}/import-big-coverages`,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  },
  {
    name: 'putUpdateBigCoverages',
    url: `${environment.newyorkApiUrl}/v3/coverage/countries/{country_id}/carriers/{carrier_id}/services/{service_id}/rates/{rate_id}/update-big-coverages`,
    method: 'put'
  },
  {
    name: 'putUpdateCoveragekm',
    url: `${environment.newyorkApiUrl}/v3/coverage/carriers/{carrier_id}/services/{service_id}/rates/{rate_id}/update-coverages-km`,
    method: 'put',
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  },
  {
    name: 'postImportPreferentialCoverage',
    url: `${environment.newyorkApiUrl}/v3/coverage/carriers/{carrier_id}/services/{service_id}/company/{company_id}/import-preferential-coverage`,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  },
  {
    name: 'postImportPreferentialBigCoverages',
    url: `${environment.newyorkApiUrl}/v3/coverage/countries/{country_id}/carriers/{carrier_id}/services/{service_id}/company/{company_id}/import-preferential-big-coverages`,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  },
  {
    name: 'putUpdateFreightCharges',
    url: `${environment.newyorkApiUrl}/v3/coverage/carriers/{carrier_id}/services/{service_id}/rates/{rate_id}/update-freight-charges`,
    method: 'put',
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  },
  {
    name: 'putReplicateCoverages',
    url: `${environment.newyorkApiUrl}/v3/coverage/carriers/{carrier_id}/services/{service_id}/rates/{rate_id}/origins/{origin_id}/replicate-coverages`,
    method: 'put',
    headers: {
      'Content-Type': 'application/json'
    }
  },
  {
    name: 'deleteRate',
    url: `${environment.newyorkApiUrl}/v3/coverage/carriers/{carrier_id}/services/{service_id}/rates/{rate_id}`,
    method: 'delete',
    notCancel: true
  },
  {
    name: 'deleteInternationalRate',
    url: `${environment.newyorkApiUrl}/v3/coverage/international-rates/{rate_id}`,
    method: 'delete',
    notCancel: true
  },
  { name: 'putUpdateBigPreferentialCoverages', url: `${environment.newyorkApiUrl}/v3/coverage/countries/{country_id}/carriers/{carrier_id}/services/{service_id}/company/{company_id}/rates/{rate_id}/update-big-preferential-coverages`, method: 'put', headers: {
    'Content-Type': 'multipart/form-data'
  }},
  { name: 'putUpdatePreferentialCoverage', url: `${environment.newyorkApiUrl}/v3/coverage/carriers/{carrier_id}/services/{service_id}/rates/{rate_id}/company/{company_id}/update-preferential-coverage`, method: 'put', headers: {
    'Content-Type': 'multipart/form-data'
  }},
  {
    name: 'getInternationalRatesByCarrierService',
    url: `${environment.newyorkApiUrl}/v3/coverage/carriers/{carrier_id}/services/{service_id}/international-coverages`,
    method: 'get'
  }
]
